export enum TokenError {
    UpdatePageTokenError = 'UpdatePageTokenError',
}
